import * as Yup from 'yup';
import { RedirectForm } from '@composite/redirect/dialog-redirect';
import { EsFileState } from '@enums';

export function useValidationSchema() {
  return Yup.object().shape({
    state: Yup.mixed<EsFileState>().nullable().required(),
  }) as Yup.Schema<RedirectForm & { state: EsFileState }>;
}
